import { render, staticRenderFns } from "./secondarydealerfilestable.vue?vue&type=template&id=1af15ae1&scoped=true&"
import script from "./secondarydealerfilestable.vue?vue&type=script&lang=js&"
export * from "./secondarydealerfilestable.vue?vue&type=script&lang=js&"
import style0 from "./secondarydealerfilestable.vue?vue&type=style&index=0&id=1af15ae1&lang=less&scoped=true&"
import style1 from "./secondarydealerfilestable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af15ae1",
  null
  
)

export default component.exports